import styles from './styles.module.scss';
import { PropTypes } from 'prop-types';
import { forwardRef } from 'react';

const RadioButtonList = forwardRef((props, ref) => {
  const { children, title, name, options, error, htmlFor, ...other } = props;

  return (
    <div className={`${styles.wrapper} ${error ? styles.error : ''}`}>
      <span className={styles.title}>{title}</span>
      <div className={styles.list}>
        {options.map((option) => (
          <label key={option.value} className={styles.label}>
            <input
              name={name}
              type="radio"
              className={styles.radio}
              value={option.value}
              {...other}
              ref={ref}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
      {children}
    </div>
  );
});

RadioButtonList.displayName = 'RadioButton';

RadioButtonList.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  htmlFor: PropTypes.string,
  name: PropTypes.string.isRequired,
  error: PropTypes.any,
  children: PropTypes.node,
};

export default RadioButtonList;
